"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const stockpile_penalty_modal_1 = __importDefault(require("./stockpile.penalty.modal"));
const store_1 = require("store");
const app_types_1 = require("pages/app.types");
const stockpile_action_1 = __importDefault(require("../stockpile.action"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const react_1 = require("react");
const authorization_1 = require("utils/authorization");
const stockpile_details_modal_1 = __importDefault(require("./stockpile.details.modal"));
const stockpile_history_modal_1 = __importDefault(require("./stockpile.history.modal"));
const stockpile_pos_1 = require("pages/stockpile-pos");
const header_menu_1 = __importDefault(require("components/molecules/header-menu"));
const stockpile_sub_component_1 = __importDefault(require("./stockpile.sub-component"));
const stockpile_mutation_component_1 = __importDefault(require("./stockpile.mutation.component"));
const modal_1 = require("components/molecules/modal");
const app_action_1 = __importDefault(require("pages/app.action"));
const react_toastify_1 = require("react-toastify");
const Stockpile = () => {
    var _a;
    const { isError, penalty, dataItem, isToast, isPenalty, isSuccess, dataDumptruck, status, errorMessage, isPushLED, messageToast, mutationMode, listDumpTruck, onCallWebSocket, isLoadingDetail, dataStatesHistory, hex_tag, onReset } = (0, store_1.useAppSelector)((state) => state.stockpile);
    const { appTheme } = (0, store_1.useAppSelector)((state) => state.app);
    const { userData } = (0, store_1.useAppSelector)((state) => state.auth);
    const { configurationCheckPointData: dataPos, hasSelectedAPos, deviceData } = (0, store_1.useAppSelector)((state) => state.stockpilePos);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [fullScreen, setFullScreen] = (0, react_1.useState)(true);
    const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, 'Stockpile');
    const accessOperatorStockpile = (0, authorization_1.userOperatorAccess)(userData.operator_access, 'Stockpile');
    const dataPushLed = Object.assign(Object.assign({}, dataPos), { brand2_disable: false, brand3_disable: false, brand4_disable: false, brand5_disable: false, inEdit: false, modified_by: '', modified_date: new Date });
    const getDataByHex = (hex) => {
        dispatch(stockpile_action_1.default.setStatus({ status: 'Online' }));
        dispatch(stockpile_action_1.default.getDataDummptruck(hex));
    };
    const url = `ws://${(_a = deviceData.find(i => i.name_device == 'PC')) === null || _a === void 0 ? void 0 : _a.ip_address}:${String(process.env.RFID_PORT)}`;
    const showToastMessage = () => {
        react_toastify_1.toast.error(messageToast, {
            position: react_toastify_1.toast.POSITION.TOP_CENTER
        });
    };
    (0, react_1.useEffect)(() => {
        if (isToast) {
            showToastMessage();
            dispatch(stockpile_action_1.default.onShowToast({
                messageToast: '',
                isToast: false
            }));
        }
    }, [isToast]);
    (0, react_1.useEffect)(() => {
        try {
            if (location.protocol !== 'https:') {
                const ws = new WebSocket(url);
                if (onCallWebSocket) {
                    ws.onopen = (i) => console.log('WS open for ', url, i);
                    ws.onmessage = function (event) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const { isError, data, errorMessage, errorType } = JSON.parse(event.data);
                            try {
                                if (!isError) {
                                    if (data.hex_tag != hex_tag) {
                                        console.log('Success', data);
                                        getDataByHex(data.hex_tag);
                                    }
                                    else {
                                        console.log('Dump Truck already scanned', hex_tag);
                                    }
                                }
                                else {
                                    console.log('Error', errorMessage, errorType);
                                    if (errorType != 'TIMEOUT')
                                        dispatch(stockpile_action_1.default.onShowToast({
                                            messageToast: errorMessage,
                                            isToast: true
                                        }));
                                }
                            }
                            catch (err) {
                                console.log('Failed', err);
                            }
                        });
                    };
                    ws.onclose = () => console.log('ws closed', url);
                }
                return () => {
                    ws.close();
                };
            }
        }
        catch (error) {
            console.error(error);
        }
        return () => {
            console.log('Please use http');
        };
    }, [onCallWebSocket]);
    (0, react_1.useEffect)(() => {
        widthCheker();
        try {
            if (location.protocol !== 'https:') {
                const ws = new WebSocket(url);
                ws.onopen = () => console.log('Pinging..');
                ws.onmessage = function (event) {
                    return __awaiter(this, void 0, void 0, function* () {
                        const { ping } = JSON.parse(event.data);
                        try {
                            if (!ping) {
                                dispatch(stockpile_action_1.default.setStatus({ status: 'Offline' }));
                            }
                            else {
                                dispatch(stockpile_action_1.default.setStatus({ status: 'Online' }));
                            }
                        }
                        catch (err) {
                            dispatch(stockpile_action_1.default.setStatus({ status: 'Offline' }));
                        }
                    });
                };
            }
        }
        catch (error) {
            console.error(error);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (isAuthorized.view) {
            if (isPushLED)
                dispatch(stockpile_action_1.default.pushLED(dataPushLed));
            if (!hasSelectedAPos)
                navigate('/choose-pos-stockpile');
            if (accessOperatorStockpile.length === 1 && !hasSelectedAPos) {
                const [{ checkpoint_id }] = accessOperatorStockpile;
                dispatch(app_action_1.default.appActionSelectMenu({ menu: 'Stockpile', subMenu: null }));
                dispatch(stockpile_pos_1.stockpilePosAction.resetSelectedPos({ hasSelectedAPos: true }));
                dispatch(stockpile_pos_1.stockpilePosAction.getLandingPageStockpile({ checkpoint_id: checkpoint_id }));
            }
        }
        else {
            navigate('/dashboard', { replace: true });
        }
    }, [isAuthorized, fullScreen, isPushLED, hasSelectedAPos]);
    (0, react_1.useEffect)(() => {
        if (isPenalty) {
            dispatch(stockpile_action_1.default.setLoadingSubmit({ isLoadingSubmit: true }));
            setTimeout(() => {
                dispatch(stockpile_action_1.default.pushLED(dataPushLed));
                dispatch(stockpile_action_1.default.onClickMutation({
                    mutationMode, isPenalty: false, onCallWebSocket: true,
                }));
            }, 5000);
        }
    }, [isPenalty]);
    (0, react_1.useEffect)(() => {
        if (mutationMode === 'passive') {
            if (listDumpTruck.length == 0)
                dispatch(stockpile_action_1.default.getDataDumptruckList());
        }
        if (mutationMode === false) {
            getHistory();
        }
    }, [mutationMode, dataItem]);
    (0, react_1.useEffect)(() => {
        if (isLoadingDetail) {
            dispatch(stockpile_action_1.default.getDataDropdown());
        }
    }, [isLoadingDetail]);
    (0, react_1.useEffect)(() => {
        const intervalId = setInterval(() => {
            if (isSuccess) {
                dispatch(stockpile_action_1.default.onClickMutation({
                    mutationMode: false,
                    isSuccess: false,
                    onCallWebSocket: false,
                    isPenalty: true,
                    penalty,
                    dataDumptruck,
                }));
                getHistory();
            }
        }, 1000);
        return () => clearInterval(intervalId);
    }, [isSuccess]);
    const widthCheker = () => {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        setFullScreen(width >= window.screen.width);
    };
    const getHistory = () => {
        const newDataStatesHistory = Object.assign(Object.assign({}, dataStatesHistory), { skip: mutationMode == false ? 0 : dataStatesHistory.skip, take: mutationMode == false ? 10 : dataStatesHistory.take, filter: {
                logic: 'and',
                filters: [{
                        field: 'pos_id',
                        operator: 'uuid',
                        value: dataPos.checkpoint_id
                    }]
            } });
        dispatch(stockpile_action_1.default.getDataHistory(newDataStatesHistory));
    };
    window.onload = widthCheker;
    window.onresize = widthCheker;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: {
            width: fullScreen ? 'auto' : 'max-content',
            height: 'inherit',
        } }, { children: [(0, jsx_runtime_1.jsx)(header_menu_1.default, { title: 'Stockpile', theme: appTheme, isLoading: status === 'Offline', isHistory: isAuthorized.view, isReset: isAuthorized.view, onReset: () => {
                    dispatch({ type: app_types_1.appTypes.RESET_LOADING });
                    dispatch(stockpile_action_1.default.onReset({ onReset: !onReset }));
                    getHistory();
                }, onHistory: () => {
                    getHistory();
                    dispatch(stockpile_action_1.default.onClickMutation({ mutationMode: 'history', onCallWebSocket, isPenalty, dataDumptruck }));
                } }), (0, jsx_runtime_1.jsx)(modal_1.ModalSuccess, { show: isSuccess, appTheme: appTheme, messageSuccess: 'Data saved Successfully', onClose: () => {
                    dispatch(stockpile_action_1.default.onClickMutation({
                        mutationMode: false,
                        isSuccess: false,
                        onCallWebSocket: false,
                        isPenalty: true,
                        penalty,
                        dataDumptruck,
                    }));
                    getHistory();
                } }), (0, jsx_runtime_1.jsx)(modal_1.ModalError, { show: isError, appTheme: appTheme, style: { zIndex: 10 }, errorMessage: errorMessage, onClose: () => {
                    dispatch(stockpile_action_1.default.toggleError({ isError: false, errorCode: 0, errorMessage: '' }));
                    dispatch(stockpile_action_1.default.onClickMutation({
                        mutationMode: mutationMode == 'modify' || mutationMode == 'passive' ? mutationMode : false,
                        onCallWebSocket: true,
                        isPenalty: false,
                        dataDumptruck,
                    }));
                } }), (0, jsx_runtime_1.jsx)(react_toastify_1.ToastContainer, { style: { zIndex: 8 } }), mutationMode === 'history' && (0, jsx_runtime_1.jsx)(stockpile_history_modal_1.default, {}), mutationMode === 'details' && (0, jsx_runtime_1.jsx)(stockpile_details_modal_1.default, {}), mutationMode === 'penalty' && (0, jsx_runtime_1.jsx)(stockpile_penalty_modal_1.default, { isAuthorized: isAuthorized }), (0, jsx_runtime_1.jsx)(stockpile_mutation_component_1.default, { isAuthorized: isAuthorized }), (0, jsx_runtime_1.jsx)(stockpile_sub_component_1.default, { isAuthorized: isAuthorized })] })));
};
exports.default = Stockpile;
